import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { PresenceAddCard } from './PresenceAddCard';
import WorkRequest from '../../../../works/ws/WorkRequest';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { PsWork } from '../PsWork';
import './PresenceAddScreen.css';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export class PresenceAddScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_PRESENCES_WORKS,
            Breadcrumbs.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
            workDescription: '',
        };
    }

    componentDidMount() {
        this.getWorkDescription();
    }

    render() {
        const { workDescription, breadcrumbs } = this.state;
        const { id } = this.props.match.params;

        return (
            <PsPage title={I18nUtils.tr('TR_ANADIR_PRESENCIAS')} breadcrumbs={breadcrumbs}>
                <h2><small className={'presence-subtitle'}>{workDescription}</small></h2>
                <PresenceAddCard workId={Number(id)}/>
            </PsPage>
        );
    }

    getWorkDescription = () => {
        const { id } = this.props.match.params;

        new WorkRequest(id)
            .onSuccess(res => {
                const work = PsWork.fromBackend(res.data);

                BreadcrumbsManagerInstance.finishLoading({
                    id: Breadcrumbs.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL.id,
                    url: this.props.location.pathname,
                    description: work.description(),
                });

                this.setState({
                    workDescription: work.description(),
                    breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
                });
            })
            .execute();
    };
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/add/PresenceAddScreen.jsx